exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".previews .v-select .v-menu__content{max-height:405px!important}", ""]);

// exports
